import React, { memo } from 'react';
import styles from './dialogActions.module.scss';

const DialogActions = ({ children }) =>
    <div className={styles.dialogActions}>
        {children}
    </div>

export default memo(DialogActions);